/**
 * `Business::AVAILABLE_TIME_ZONES` on the API (`app/models/business.rb`), each
 * label with the IANA zone dayjs reads. This is the one copy in web:
 * onboarding offers its labels, and Accounts Payable reads business days
 * through it. When the API adds a zone, add it here too.
 */
export const BUSINESS_TIME_ZONE_IANA = {
  "Pacific Time (US & Canada)": "America/Los_Angeles",
  Arizona: "America/Phoenix",
  "Mountain Time (US & Canada)": "America/Denver",
  "Central Time (US & Canada)": "America/Chicago",
  "Eastern Time (US & Canada)": "America/New_York",
  UTC: "UTC",
} as const;

export type BusinessTimeZoneLabel = keyof typeof BUSINESS_TIME_ZONE_IANA;

/** Whether a stored `time_zone_label` is one the API offers. */
export const isBusinessTimeZoneLabel = (
  label: string | null | undefined,
): label is BusinessTimeZoneLabel =>
  !!label && Object.hasOwn(BUSINESS_TIME_ZONE_IANA, label);

/**
 * The IANA zone for a business's `time_zone_label`, or undefined when the
 * label is missing or unknown (callers then fall back to the viewer's zone).
 */
export const businessIanaTimeZone = (
  label: string | null | undefined,
): string | undefined =>
  isBusinessTimeZoneLabel(label) ? BUSINESS_TIME_ZONE_IANA[label] : undefined;
